import React, { useState , useEffect} from 'react';
import Icon from "components/Icon";
import { Link } from "react-router-dom";
import formatTime from "utils/formatTime";
import { useUsersContext } from "context/usersContext";
import defaultPic from "../../assets/images/default_profile_image.jpeg";
import getProviderLogoCall from "../../utils/getProviderLogoCall"
import { Cookies } from 'react-cookie';
import jwt from 'jsonwebtoken'
import notificationSound from '../../assets/notificatio.mp3';


const Contact = ({ contact }) => {
	const { setUserAsUnread, setBotStatus } = useUsersContext();
	const [closeButtonCliecked, setCloseButtonClicked] = useState(false);
	const [rollBackButtonClicked, setRollbackButtonClicked] = useState(false);

	const audio = new Audio(notificationSound);

	useEffect(() => {
		const showNotification = () => {
		  if (Notification.permission === "granted") {
			const options = {
			  body: `הודעה חדשה מ- ${contact.name}`,
			  icon: '../../assets/finiti.ico'
			};
			const notification = new Notification('הודעה חדשה', options);
		  }
		  audio.play();
		};
	  
		if (contact.unread > 0) {
		  showNotification();
		}
	  }, [contact.unread]);
	  

	const getLastMessage = () => {
		const messageDates = Object.keys(contact.messages);
		const recentMessageDate = messageDates[messageDates.length - 1];
		const messages = [...contact.messages[recentMessageDate]];
		const lastMessage = messages.pop();
		return lastMessage;
	};

	const notify = (title, body) => {

		if (!("Notification" in window)) {
			console.log("This browser does not support desktop notification");
		  }
		  else if (Notification.permission !== "granted") {
			Notification.requestPermission().then(permission => {
			  if (permission === "granted") {
				console.log("Notification permission granted");
			  }
			});
		  }

		if (Notification.permission === "granted") {
		  const notification = new Notification(title, { body });
		  const audio = new Audio('/path/to/sound.mp3');
		  audio.play();
		}
	  };

	const lastMessage = getLastMessage(contact);

	const lastMessageStatus = (value) => {
		switch(value) {
		  case 'sent':
			return 'singleTick';
		case 'delivered':
			return 'doubleTick';
		case 'read':
			return 'doubleTick';
		  default:
			return 'undelivered';
		}
	  }

	return (


		<Link
			className="sidebar-contact"
			to={`/chat/${contact._id}`}
			onClick={() => setUserAsUnread(contact._id)}
			// preventscrollreset={true}
			// {...(contact.unread > 0 && { onClick: setUserAsUnread(contact._id)})}
		>
	
			<div className="sidebar-contact__avatar-wrapper">
				<img
					src={contact.profile_picture ? contact.profile_picture : defaultPic}
					alt={contact.name}
					className="avatar"
				/>
			</div>
			<div className="sidebar-contact__content">
				<div className="sidebar-contact__top-content">
					<h2 className="sidebar-contact__name">  {contact.name? contact.name : '0'+ contact.phone.replace(/\D/g, '').slice(-9) }</h2>
					<span className="sidebar-contact__time">
						{formatTime(lastMessage.createdAt)}
					</span>
				</div>
				<div className="sidebar-contact__bottom-content">
					<p className="sidebar-contact__message-wrapper">
						{lastMessage.status && (
							<Icon
								id={
									lastMessageStatus(lastMessage.status)
									// lastMessage.status === "sent" ? "singleTick" : "doubleTick"
								}
								aria-label={lastMessage.status}
								className={`sidebar-contact__message-icon ${
									lastMessage.status === "read"
										? "sidebar-contact__message-icon--blue"
										: ""
								}`}

						
							/>
						)}
						<span
							className={`sidebar-contact__message ${
								!!contact.unread ? "sidebar-contact__message--unread" : ""
							}`}
						>
							{contact?.typing ? <i> typing...</i> : lastMessage?.body}
						</span>
					</p>
					<div className="sidebar-contact__btn">
						{/* {contact?.pinned && (
							<Icon id="pinned" className="sidebar-contact__icon" />
						)} */}
						{/* {!!contact?.unread && notify("הודעה חדשה נכנסה", contact.phone+'' +lastMessage?.body )(
							<span className="sidebar-contact__unread">{contact?.unread}</span>

						)} */}

						{!!contact?.unread &&(
							<span className="sidebar-contact__unread">{contact?.unread}</span>
						)}
						{contact?.botStatus === 3 && (
						<button aria-label="sidebar-contact__btn" onClick={() => {
							setBotStatus(contact._id,2)
							setRollbackButtonClicked(true)
							}} >
							{!rollBackButtonClicked ?
							<Icon
								id="rollBackToPending"
								className="sidebar-contact__icon sidebar-contact__icon--dropdown"
							/>	: 
								<Icon
								id="rollBackToPending"
								className="sidebar-contact__icon sidebar-contact__icon--dropdown"
							/>
							}
						</button>
						)}
						{contact?.botStatus !== 3 && (
						<button aria-label="sidebar-contact__btn" onClick={() => {
							setBotStatus(contact._id,3)
							setCloseButtonClicked(true)
							}} >
							
							{!closeButtonCliecked ?
							<Icon
								id="closeButtonNotPressed"
								className="sidebar-contact__icon sidebar-contact__icon--dropdown"
							/>	: 
								<Icon
								id="closeButtonPressed"
								className="sidebar-contact__icon sidebar-contact__icon--dropdown"
							/>
							}
						</button>
						)}
						{contact?.botStatus === 3 && (
						<button aria-label="sidebar-contact__btn" onMouseOver="ssss" onClick={() => {
							setBotStatus(contact._id,1)
							setCloseButtonClicked(false)
							}} >
							
							{!closeButtonCliecked ?
							<Icon
								id="closeButtonNotPressed"
								className="sidebar-contact__icon sidebar-contact__icon--dropdown"
							/>	: 
								<Icon
								id="closeButtonPressed"
								className="sidebar-contact__icon sidebar-contact__icon--dropdown"
							/>
							}
						</button>
						)}
					</div>
				</div>
			</div>
		</Link>
	);
};

export default Contact;
